import React, { useEffect, useState, useRef } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { ChevronUp } from "feather-icons-react/build/IconComponents";
import { setToogleHeader } from "../../core/redux/action";
import { useDispatch, useSelector } from "react-redux";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import Table from "../../core/pagination/datatable";
import Loader from "../loader/loader";
import { useToast } from "../../Toaster/ToastContext";
import { apiClient } from "../../services/apiClient";
import { LeftOutlined, RightOutlined } from "@ant-design/icons"

const ExpiredProduct = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [originalExpiredProducts, setOriginalExpiredProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const { showToast } = useToast();
  const isDeleting = useRef(false);
  const [permissions, setPermissions] = useState({
    create: false,
    read: false,
    update: false,
    delete: false,
  });

  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 20,
    totalPages: 0,
    totalCount: 0,
  });

  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  useEffect(() => {
    const storedPermissions = localStorage.getItem("rolespermissions");
    let parsedPermissions = [];
    try {
      const Permissions = JSON.parse(storedPermissions);
      const getPermissions = JSON.parse(Permissions.permissions);
      if (getPermissions.permissions) {
        parsedPermissions = getPermissions.permissions;
      } else {
        parsedPermissions = getPermissions;
      }

      const inventoryPermissions = parsedPermissions.find(
        (item) => item.title === "Inventory"
      );

      const productPermissions = inventoryPermissions?.childPage?.find(
        (child) => child.title === "Expired Products"
      );
      // console.log("search product", productPermissions)

      if (productPermissions) {
        setPermissions({
          create: productPermissions.create || false,
          read: productPermissions.read || false,
          update: productPermissions.update || false,
          delete: productPermissions.delete || false,
        });
      } else {
        console.error("Product permissions not found in localStorage");
        showToast(
          "Product permissions not found.",
          "error",
          "Permissions Error"
        );
      }
    } catch (error) {
      // console.error("Error parsing permissions from localStorage:", error);
      showToast("Failed to load permissions.", "error", "Permissions Error");
    }
  }, []);

  const fetchExpiredProducts = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get("/get-all-products");
      const products = response.data;
      const currentDate = new Date();
      const expiredProducts = products
        .filter(
          (product) =>
            product.expiry_on && new Date(product.expiry_on) < currentDate
        )
        .map((product) => ({
          id: product.id || "",
          product: product.name || "No Name",
          branchName: product.branch_name || "N/A",
          sku: product.sku || "No SKU",
          manufactureddate: product.manufacturer_date || "N/A",
          expireddate: product.expiry_on || "N/A",
          img: Array.isArray(product.image)
            ? product.image[0]
            : product.image || "",
        }));
      setOriginalExpiredProducts(expiredProducts);
      setFilteredProducts(expiredProducts);
      setPagination((prev) => ({
        ...prev,
        totalCount: expiredProducts.length,
        totalPages: Math.ceil(expiredProducts.length / prev.pageSize),
      }));
    } catch (error) {
      // console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchExpiredProducts();
  }, []);

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();

    if (term === "") {
      setFilteredProducts(originalExpiredProducts);
      setPagination((prev) => ({
        ...prev,
        currentPage: 1,
        totalCount: originalExpiredProducts.length,
        totalPages: Math.ceil(originalExpiredProducts.length / prev.pageSize),
      }));
      return;
    }

    const filtered = originalExpiredProducts.filter(
      (product) =>
        (product.product && product.product.toLowerCase().includes(term)) ||
        (product.sku && product.sku.toLowerCase().includes(term)) ||
        (product.branchName && product.branchName.toLowerCase().includes(term))
    );

    setFilteredProducts(filtered);
    setPagination((prev) => ({
      ...prev,
      currentPage: 1, // Reset to page 1 on search
      totalCount: filtered.length,
      totalPages: Math.ceil(filtered.length / prev.pageSize),
    }));
  };

  const { currentPage, pageSize, totalPages, totalCount } = pagination;
  const startItem = totalCount > 0 ? (currentPage - 1) * pageSize + 1 : 0;
  const endItem = Math.min(startItem + pageSize - 1, totalCount);

  // Slice filteredProducts for the current page
  const paginatedProducts = filteredProducts.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  // Generate pages to show in pagination
  const pagesToShow = [];
  if (totalPages > 0) {
    if (totalPages <= 2) {
      for (let i = 1; i <= totalPages; i++) {
        pagesToShow.push(i);
      }
    } else {
      let middle = [];
      if (currentPage === 1) {
        middle = [1, 2];
      } else if (currentPage === totalPages) {
        middle = [totalPages - 1, totalPages];
      } else {
        middle = [currentPage, currentPage + 1];
      }

      if (middle[0] > 1) {
        pagesToShow.push(1);
      }
      if (middle[0] > 2) {
        pagesToShow.push("...");
      }
      middle.forEach((p) => pagesToShow.push(p));
      if (middle[1] < totalPages - 1) {
        pagesToShow.push("...");
      }
      if (middle[1] < totalPages) {
        pagesToShow.push(totalPages);
      }
    }
  }

  // Handle page change
  const changePage = (page) => {
    setPagination((prev) => ({
      ...prev,
      currentPage: page,
    }));
  };

  const columns = [
    {
      title: "Product",
      dataIndex: "product",
      render: (text, record) => (
        <span className="productimgname">
          <Link to="#" className="product-img stock-img">
            <ImageWithBasePath
              alt=""
              src={
                record.img ||
                "https://odabill.com/assets/img/product/noimage.png"
              }
            />
          </Link>
          <span className="wrap-text">{text}</span>
        </span>
      ),
      sorter: (a, b) => a.product.length - b.product.length,
      width: 200,
    },
    {
      title: "Branch",
      dataIndex: "branchName",
      render: (text) => <span className="wrap-text">{text || "N/A"}</span>,
      sorter: (a, b) => a.branchName.length - b.branchName.length,
      width: 200,
    },
    {
      title: "SKU",
      dataIndex: "sku",
      sorter: (a, b) => a.sku.length - b.sku.length,
      render: (text) => <span className="wrap-text">{text || "N/A"}</span>,
      width: 200,
    },
    {
      title: "Manufactured Date",
      dataIndex: "manufactureddate",
      render: (text) => {
        const date = new Date(text);
        return isNaN(date)
          ? "N/A"
          : date
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
              .split("/")
              .join("-");
      },
      sorter: (a, b) => a.manufactureddate.length - b.manufactureddate.length,
      width: 200,
    },
    {
      title: "Expired Date",
      dataIndex: "expireddate",
      render: (text) => {
        const date = new Date(text);
        return isNaN(date)
          ? "N/A"
          : date
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
              .split("/")
              .join("-");
      },
      sorter: (a, b) => a.expireddate.length - b.expireddate.length,
      width: 200,
    },
  ];

  // ✅ Add "Action" column only if delete permission exists
  if (permissions.delete) {
    columns.push({
      title: "Action",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link className="confirm-text p-2" to="#">
              <i
                data-feather="trash-2"
                className="feather-trash-2"
                onClick={() => showConfirmationAlert(record)}
              ></i>
            </Link>
          </div>
        </div>
      ),
      width: 100,
    });
  }

  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = (record) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          isDeleting.current = true;
          const response = await apiClient.delete(
            `/delete-product/${record.id}`
          );
          const data = await response;
          if (data.success) {
            showToast(
              "Product deleted successfully",
              "success",
              "Product Operation!"
            );
            await fetchExpiredProducts();
          } else {
            showToast(
              data.message || "Failed to delete product",
              "error",
              "Product Operation!"
            );
          }
        } catch (error) {
          showToast(
            error.message || "Failed to delete product",
            "error",
            "Product Operation!"
          );
        } finally {
          setLoading(false);
          isDeleting.current = false;
        }
      } else {
        MySwal.close();
      }
    });
  };
  return (
    <div>
      <Loader loading={loading} />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Expired Products</h4>
                <h6>Manage your expired products</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={data ? "active" : ""}
                    onClick={() => {
                      dispatch(setToogleHeader(!data));
                    }}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="search-input">
                    <input
                      type="text"
                      placeholder="Search products by name, branch and sku... "
                      className="form-control form-control-sm formsearch"
                      onChange={handleSearch}
                    />
                    <Link to className="btn btn-searchset">
                      <i data-feather="search" className="feather-search" />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="table-responsive">
                <Table
                  columns={columns}
                  dataSource={paginatedProducts}
                  rowSelection={null}
                  pagination={false}
                />
              </div>

              {totalCount > 0 && (
                <div className="custom-pagination d-flex justify-content-between align-items-center mt-4 mb-4">
                  <div className="pagination-left">
                    Showing {startItem} - {endItem} of {totalCount}
                  </div>
                  <div className="pagination-right d-flex align-items-center">
                    <button
                      className="btn btn-sm btn-outline-secondary me-2"
                      disabled={currentPage === 1}
                      onClick={() => changePage(currentPage - 1)}
                    >
                      <LeftOutlined size={12} />
                    </button>
                    {pagesToShow.map((page, index) => (
                      <span key={index} className="me-2">
                        {page === "..." ? (
                          <span className="pagination-ellipsis">...</span>
                        ) : (
                          <button
                            className={`btn btn-sm ${
                              page === currentPage
                                ? "btn-primary"
                                : "btn-outline-secondary"
                            }`}
                            onClick={() => changePage(page)}
                          >
                            {page}
                          </button>
                        )}
                      </span>
                    ))}
                    <button
                      className="btn btn-sm btn-outline-secondary ms-2"
                      disabled={currentPage === totalPages}
                      onClick={() => changePage(currentPage + 1)}
                    >
                      <RightOutlined size={12} />
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
          {/* /product list */}
        </div>
      </div>
    </div>
  );
};

export default ExpiredProduct;
